import {
    ADD_FIM_NOTES,
    ADD_FIM_NOTES_SUCCESS,
    ADD_FIM_NOTES_FAILURE,
    GET_FIM_NOTES,
    GET_FIM_NOTES_SUCCESS,
    GET_FIM_NOTES_FAILURE,
    EDIT_FIM_NOTES,
    EDIT_FIM_NOTES_SUCCESS,
    EDIT_FIM_NOTES_FAILURE,
    RESET_FIM_NOTES,
} from '../actions';

const initialState = {
    notes: [],
    loading: false,
    addNotesSuccess: false,
    editNotesSuccess: false,
    getNotesSuccess: false,
    error: null,
};

const fimAddNotesReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_FIM_NOTES:
            return {
                ...state,
                loading: true,
                addNotesSuccess: false,
                error: null,
            };
        case ADD_FIM_NOTES_SUCCESS: {
            // Check if note already exists (for edit scenario)
            const existingNoteIndex = state.notes.findIndex(
                (note) => 
                    note.setNumber === action.payload.setNumber && 
                    note.sapOrderNumber === action.payload.sapOrderNumber && 
                    note.sapLineNumber === action.payload.sapLineNumber
            );
            
            let updatedNotes;
            if (existingNoteIndex !== -1) {
                // Update existing note
                updatedNotes = state.notes.map((note, index) => 
                    index === existingNoteIndex ? action.payload : note
                );
            } else {
                // Add new note
                updatedNotes = [...state.notes, action.payload];
            }
            
            return {
                ...state,
                loading: false,
                error: null,
                addNotesSuccess: true,
                notes: updatedNotes,
            };
        }
        case ADD_FIM_NOTES_FAILURE:
            return {
                ...state,
                loading: false,
                addNotesSuccess: false,
                error: action.payload.error,
            };

        case GET_FIM_NOTES:
            return {
                ...state,
                error: null,
                loading: true,
            };
        case GET_FIM_NOTES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                notes: action.payload,
            };
        case GET_FIM_NOTES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };

        case EDIT_FIM_NOTES:
            return {
                ...state,
                loading: true,
                error: null,
                editNotesSuccess: false,
                notes: state.notes,
            };
        case EDIT_FIM_NOTES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                editNotesSuccess: true,
                notes: state.notes.map((note) =>
                    note.id === action.payload.id ? action.payload : note
                ),
            };
        case EDIT_FIM_NOTES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                editNotesSuccess: false,
            };

        case RESET_FIM_NOTES:
            return initialState;
        default:
            return state;
    }
};

export default fimAddNotesReducer;

// export default fimAddNotesReducer;
